import React from "react";
import PropTypes from "prop-types";
import { FilterDatePicker } from "@td/ui";
import { translate } from "@td/shared_utils";

const filterDropdownProps = {
  "data-testid": "due-date-filter",
};

const DueDateFilter = React.memo((props) => (
  <FilterDatePicker
    {...props}
    selectsRange
    label={translate(null, "care_team_tasks.filters.fields.due_date", "label")}
    placeholder={translate(null, "care_team_tasks.filters.fields.due_date", "placeholder")}
    filterDropdownProps={filterDropdownProps}
  />
));

DueDateFilter.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

DueDateFilter.displayName = "DueDateFilter";

export default DueDateFilter;
